export const getSearchCriteria = (state) => state.searchCriteria;
